RivalIQ.apps.Dashboard.module('controller', function (controller, App, Backbone, Marionette, $, _) {

    'use strict';

    const Controller = controller.Controller = Marionette.Dashboard.Controller.extend({
        regions: App.getRegions(),

        logXhrError: function (xhr) {
            RivalIQ.errors.script.reportError([
                'Uncaught curation xhr',
                xhr.status,
                xhr.errorName,
                xhr.errorMessage,
                window.location
            ].join('; '), xhr);
        },

        logError: function (error) {
            RivalIQ.errors.script.reportError([
                'Uncaught curation error',
                window.location,
                error.toString(),
                JSON.stringify(error),
                error.stack
            ].join('; '), error);
        },

        handleCurationError: function (curation, error) {
            const me = this;

            // don't log errors if the user requested too much data/history
            const statusCodesToIgnore = [413];

            // Allow custom handling of error responses
            if (error.render) {
                return me.regions.widgetsRegion.show(error);
            }

            if (_.isString(error)) {
                Backbone.history.navigate(error, {
                    trigger: true
                });
                return;
            }

            if (error.status === 0 || error.readyState === 0) {
                // XHR was cancelled due to navigation; ignore it
                // see https://stackoverflow.com/questions/1023867/jquery-xmlhttprequest-error
                return;
            } else if (error.status && _.includes(statusCodesToIgnore, error.status)) {
                // don't log, but do show the curation error view
            } else if (error.status) {
                // HTTP error response
                me.logXhrError(error);
            } else {
                // other error
                me.logError(error);
            }

            me.regions.widgetsRegion.show(new App.views.CurationErrorView());
        },

        handler: function () {
            const me = this;

            me.showCurationLoading();
            Marionette.Dashboard.Controller.prototype.handler.apply(me, arguments);
        },

        handleUnknownRoute: function () {
            const me = this;

            // redirect any old urls for "post-tags-manager" to "post-tag-manager" (singular).
            const fragment = Backbone.history.getFragment() || '';
            const oldPostTagsManagerLink = _.startsWith(fragment, 'post-tags-manager');
            if (oldPostTagsManagerLink) {
                const newFragment = `post-tag-manager${fragment.slice('post-tags-manager'.length)}`;
                return Backbone.history.navigate(newFragment, {
                    trigger: true
                });
            }

            if (me.regions.widgetsRegion && me.regions.widgetsRegion.$el.length) {
                me.regions.widgetsRegion.show(new App.views.UnknownCurationView());
            }
        },

        showCurationLoading: function () {
            const me = this;

            me.regions.widgetsRegion.showLoading();
        },

        teardownCuration: function () {
            const me = this;

            // don't showLoading here as that will trigger the sync destroy of the existing widgets.
            me.regions.widgetsRegion.$el.children().addClass('display-none');
            Marionette.Dashboard.Controller.prototype.teardownCuration.apply(me, arguments);
        }
    });


    controller.addInitializer(function () {

        const appController = new Controller();

        const router = App.router.router = new App.router.Router({
            controller: appController
        });
        mountCurations(router);

        router.interceptNavigation();
    });

    function mountCurations(router) {
        // NOTE you must NEVER add a route parameter named `id` as it will
        // override the `curation.id` (which causes subtle, but extreme pain)

        let mountpoints = [
            {
                curation: RivalIQ.enums.curation.COMPANIES,
                path: 'companies',
                app: RivalIQ.apps.Companies.curations.Companies
            },
            {
                curation: RivalIQ.enums.curation.SOCIALPOSTS,
                path: 'posts(/:channel)',
                app: RivalIQ.apps.SocialPosts.curations.SocialPosts
            },
            {
                curation: RivalIQ.enums.curation.POSTTAGS,
                path: 'post-tags(/:channel)',
                app: RivalIQ.apps.SocialPosts.curations.PostTags
            },
            {
                curation: RivalIQ.enums.curation.POSTTAGSMANAGER,
                path: 'post-tag-manager(/:channel)',
                app: RivalIQ.apps.SocialPosts.curations.PostTagsManager
            },
            {
                curation: RivalIQ.enums.curation.POSTED_URLS,
                path: 'posted-urls(/:channel)',
                app: RivalIQ.apps.SocialPosts.curations.PostedUrls
            },
            {
                curation: RivalIQ.enums.curation.TWITTER_INSIGHTS,
                path: 'insights/twitter(/:companyId)',
                app: RivalIQ.apps.Insights.curations.TwitterInsightsCuration
            },
            {
                curation: RivalIQ.enums.curation.TWITTER_INSIGHTS_POSTS,
                path: 'insights/twitter(/:companyId)/posts',
                app: RivalIQ.apps.Insights.curations.TwitterInsightsPostsCuration
            },
            {
                curation: RivalIQ.enums.curation.FACEBOOK_ADS_INSIGHTS,
                path: 'ads/facebook(/:adAccountId)(/:adObjectId)(/:exploreLevel)',
                app: RivalIQ.apps.AdsInsights.curations.FacebookAdsInsightsCuration
            },
            {
                curation: RivalIQ.enums.curation.FACEBOOK_INSIGHTS_POST_DETAILS,
                path: 'insights/facebook/:companyId/posts/:postId',
                app: RivalIQ.apps.Insights.curations.FacebookInsightsPostDetailsCuration
            },
            {
                curation: RivalIQ.enums.curation.FACEBOOK_INSIGHTS_REEL_DETAILS,
                path: 'insights/facebook/:companyId/reels/:postId',
                app: RivalIQ.apps.Insights.curations.FacebookInsightsReelDetailsCuration
            },
            {
                curation: RivalIQ.enums.curation.FACEBOOK_INSIGHTS,
                path: 'insights/facebook(/:companyId)',
                app: RivalIQ.apps.Insights.curations.FacebookInsightsCuration
            },
            {
                curation: RivalIQ.enums.curation.FACEBOOK_INSIGHTS_POSTS,
                path: 'insights/facebook(/:companyId)/posts',
                app: RivalIQ.apps.Insights.curations.FacebookInsightsPostsCuration
            },
            {
                curation: RivalIQ.enums.curation.INSTAGRAM_INSIGHTS,
                path: 'insights/instagram(/:companyId)',
                app: RivalIQ.apps.Insights.curations.InstagramInsightsCuration
            },
            {
                curation: RivalIQ.enums.curation.INSTAGRAM_INSIGHTS_POSTS,
                path: 'insights/instagram(/:companyId)/posts',
                app: RivalIQ.apps.Insights.curations.InstagramInsightsPostsCuration
            },
            {
                curation: RivalIQ.enums.curation.INSTAGRAM_INSIGHTS_STORIES,
                path: 'insights/instagram(/:companyId)/stories',
                app: RivalIQ.apps.Insights.curations.InstagramInsightsStoriesCuration
            },
            {
                curation: RivalIQ.enums.curation.INSTAGRAM_INSIGHTS_STORY_DAY,
                path: 'insights/instagram/:companyId/stories/:storyDay',
                app: RivalIQ.apps.Insights.curations.InstagramInsightsStoryDayCuration
            },
            {
                curation: RivalIQ.enums.curation.LINKEDIN_INSIGHTS,
                path: 'insights/linkedin(/:accountPresenceId)',
                app: RivalIQ.apps.Insights.curations.LinkedInInsightsCuration
            },
            {
                curation: RivalIQ.enums.curation.LINKEDIN_INSIGHTS_POSTS,
                path: 'insights/linkedin(/:accountPresenceId)/posts',
                app: RivalIQ.apps.Insights.curations.LinkedInInsightsPostsCuration
            },
            {
                curation: RivalIQ.enums.curation.OVERVIEW,
                path: 'overview(/:channel)',
                app: RivalIQ.apps.Overview.curations.Overview
            },
            {
                curation: RivalIQ.enums.curation.LEADERBOARD,
                path: 'leaderboard(/:channel)',
                app: RivalIQ.apps.Overview.curations.Leaderboard
            },
            {
                curation: RivalIQ.enums.curation.REPORT_CENTER,
                path: 'downloads',
                app: RivalIQ.apps.Reports.curations.ReportCenter
            },
            {
                curation: RivalIQ.enums.curation.REPORTS,
                path: 'reports',
                app: RivalIQ.apps.Reports.curations.Reports
            },
            {
                curation: RivalIQ.enums.curation.REPORT,
                path: 'report(/:reportId)',
                app: RivalIQ.apps.Reports.curations.Report
            },
            {
                curation: RivalIQ.enums.curation.SCHEDULED_REPORTS,
                path: 'reports/scheduled',
                app: RivalIQ.apps.Reports.curations.Scheduled
            },
            {
                curation: RivalIQ.enums.curation.ALERTS,
                path: 'alerts',
                app: RivalIQ.apps.Alerts.curations.Alerts
            },
            {
                curation: RivalIQ.enums.curation.COMPANY_CHANNELS,
                path: 'company/:companyId',
                app: RivalIQ.apps.CompanyProfile.curations.Channels
            },
            {
                curation: RivalIQ.enums.curation.COMPANY_ALERTS,
                path: 'company/:companyId/feed',
                app: RivalIQ.apps.CompanyProfile.curations.Alerts
            },
            {
                curation: RivalIQ.enums.curation.COMPANY_SOCIALPOSTS,
                path: 'company/:companyId/posts(/:channel)',
                app: RivalIQ.apps.CompanyProfile.curations.Posts
            },
            {
                curation: RivalIQ.enums.curation.ACCOUNT,
                path: 'account/:action(/:actionTypeId)',
                app: RivalIQ.apps.AccountSettings.curations.Account,
                readOnly: true
            },
            {
                curation: RivalIQ.enums.curation.ACCOUNT_JOIN,
                path: 'account/join(/:state)',
                app: RivalIQ.apps.AccountSettings.curations.Join,
                readOnly: true
            },
            {
                curation: RivalIQ.enums.curation.INVOICES,
                path: 'admin/invoices/:accountId',
                app: RivalIQ.apps.Admin.curations.Invoices
            },
            {
                curation: RivalIQ.enums.curation.METRICS_EXPLORER,
                path: 'admin/metrics-explorer',
                app: RivalIQ.apps.MetricsExplorer.curations.MetricsExplorer
            },
            {
                curation: RivalIQ.enums.curation.CHARTS,
                path: 'analyze(/:channel)',
                app: RivalIQ.apps.Analyze.curations.Analyze
            },
            {
                curation: RivalIQ.enums.curation.CHARTS_POSITIONING,
                path: 'positioning',
                app: RivalIQ.apps.Analyze.curations.Positioning
            },

            // Multi dashboard routes
            {
                curation: RivalIQ.enums.curation.DASHBOARDS,
                path: 'dashboards(/:configurationId)',
                app: RivalIQ.apps.Analyze.curations.Favorites.extend({
                    isCustomDashboard: true
                }),
                readOnly: true
            },
            {
                curation: RivalIQ.enums.curation.DASHBOARDS_TEMPLATES,
                path: 'dashboards/templates',
                app: RivalIQ.apps.Favorites.curations.Templates.extend({
                    isCustomDashboard: true
                })
            },
            {
                curation: RivalIQ.enums.curation.DASHBOARDS_CREATE,
                path: 'dashboards/new',
                app: RivalIQ.apps.Favorites.curations.Create.extend({
                    isCustomDashboard: true
                })
            },
            {
                curation: RivalIQ.enums.curation.DASHBOARDS_EMPTY,
                path: 'dashboards/empty',
                app: RivalIQ.apps.Favorites.curations.Empty.extend({
                    isCustomDashboard: true
                }),
                readOnly: true
            },
            {
                curation: RivalIQ.enums.curation.DASHBOARDS_EDIT,
                path: 'dashboards/:configurationId/edit',
                app: RivalIQ.apps.Favorites.curations.Create.extend({
                    isCustomDashboard: true
                })
            },
            {
                curation: RivalIQ.enums.curation.DASHBOARDS_PICKER,
                path: 'dashboards/:configurationId/create',
                app: RivalIQ.apps.Favorites.curations.Picker.extend({
                    isCustomDashboard: true
                })
            },
            {
                curation: RivalIQ.enums.curation.DASHBOARDS_BUILDER,
                path: 'dashboards/:configurationId/create/:widgetGroupId',
                app: RivalIQ.apps.Favorites.curations.Builder.extend({
                    isCustomDashboard: true
                })
            },
            {
                curation: RivalIQ.enums.curation.DASHBOARDS_WIDGET_EDIT,
                path: 'dashboards/:configurationId/edit/:focusWidgetInstanceId',
                app: RivalIQ.apps.Favorites.curations.Builder.extend({
                    isCustomDashboard: true
                })
            },
            {
                curation: RivalIQ.enums.curation.DISCOVERY,
                path: 'discover/:channel(/:nativePresenceId)',
                app: RivalIQ.apps.Discovery.curations.DiscoveryCuration
            },

            // React Curations
            {
                curation: RivalIQ.enums.curation.LISTENING_SEARCH,
                path: 'listening/search',
                app: RivalIQ.apps.Dashboard.models.ReactCurationBridge
            },
            {
                curation: RivalIQ.enums.curation.LISTENING_SAVED_SEARCH_BUILDER,
                path: 'listening/savedsearchbuilder(/:editingListeningQueryId)',
                app: RivalIQ.apps.Dashboard.models.ReactCurationBridge
            },
            {
                curation: RivalIQ.enums.curation.LISTENING_SAVED_SEARCHES,
                path: 'listening',
                app: RivalIQ.apps.Dashboard.models.ReactCurationBridge
            },
            {
                curation: RivalIQ.enums.curation.LISTENING_QUID_TOPICS,
                path: 'listening/topics',
                app: RivalIQ.apps.Dashboard.models.ReactCurationBridge
            },
            {
                curation: RivalIQ.enums.curation.LISTENING_ACCOUNT_USAGE,
                path: 'account/listening',
                app: RivalIQ.apps.Dashboard.models.ReactCurationBridge
            },
            {
                curation: RivalIQ.enums.curation.TIKTOK_INSIGHTS,
                path: 'insights/tiktok(/:companyId)',
                app: RivalIQ.apps.Dashboard.models.ReactCurationBridge
            },
            {
                curation: RivalIQ.enums.curation.TIKTOK_INSIGHTS_VIDEOS,
                path: 'insights/tiktok(/:companyId)/videos',
                app: RivalIQ.apps.Dashboard.models.ReactCurationBridge
            },
            {
                curation: RivalIQ.enums.curation.TIKTOK_INSIGHTS_VIDEOS,
                path: 'insights/tiktok(/:companyId)/posts',
                app: RivalIQ.apps.Dashboard.models.ReactCurationBridge
            }
        ];

        mountpoints = _.reject(mountpoints, function (mountpoint) {
            if (mountpoint.excludeForBeta && RivalIQ.state.account.inBeta(mountpoint.excludeForBeta)) {
                return true;
            }

            if (mountpoint.beta && !RivalIQ.state.account.inBeta(mountpoint.beta)) {
                return true;
            }

            return false;
        });

        const isReadOnly = RivalIQ.state.user.isReadOnly();
        _.each(mountpoints, function (mountpoint) {

            // if this path is not allowed in read only, mount the 'redirect' app...
            if (isReadOnly && !mountpoint.readOnly) {
                router.mount(
                    mountpoint.curation,
                    mountpoint.path,
                    RivalIQ.apps.Analyze.curations.Favorites.extend({
                        redirectToDashboard: true,
                        isCustomDashboard: true
                    })
                );
            } else {
                router.mount(mountpoint.curation, mountpoint.path, mountpoint.app);
            }

        });
    }
});
